import { PageListCachedDataSource } from './BaseDataSources';
import { ISeller } from '../Interfaces';

export class SellerSource extends PageListCachedDataSource<ISeller> {
 /**
 * @param {boolean} isActive - An optional parameter for filtering active records.
 */
  public constructor(isActive?: boolean, counterpartyId: string | null = null) {
    // If counterpartyId is provided, set the URL to include it
    super('/datasource/sellers', { isActive, counterpartyId });
  }
}